import { render } from "./MobilePopup.vue?vue&type=template&id=8f0ae252&scoped=true"
import script from "./MobilePopup.vue?vue&type=script&lang=js"
export * from "./MobilePopup.vue?vue&type=script&lang=js"

import "./MobilePopup.vue?vue&type=style&index=0&id=8f0ae252&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0ae252"]])

export default __exports__